import { z } from "zod";

const Provider = z.object({
  id: z.string(),
  name: z.string(),
});

const ProviderUserFacility = z.object({
  id: z.string(),
  provider: Provider,
});

const ProviderUserFacilitiesConnection = z.object({
  nodes: z.array(ProviderUserFacility),
});

export const AuditorUser = z.object({
  claimIntakeEnabled: z.boolean(),
  createdAt: z.string(),
  email: z.string(),
  firstName: z.string(),
  id: z.string(),
  internalOnly: z.boolean().optional().nullable(),
  lastName: z.string(),
  providerId: z.string().optional().nullable(),
  providerUserFacilities: ProviderUserFacilitiesConnection,
  readOnly: z.boolean().optional().nullable(),
  title: z.string().optional().nullable(),
  updatedAt: z.string(),
});
export type AuditorUser = z.infer<typeof AuditorUser>;
